export { Dot } from './Dot';
